import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { MainFilters } from '@services/FiltersTypes';

export const DEFAULT_VOLUME = 'Units';
export const DEFAULT_UNITS_PLK = 'Units (PLK)';

/**
 * @return volume string
 *
 * @remarks
 * To filter fact volume based on current selected period type and get the volume string
 *
 * @param filters - MainFilters
 * @param timeFrame - Periodicity
 * **/
export const getVolumeBasedOnPeriodType = (filters: MainFilters, timeFrame: Periodicity): string => {
  if (!filters?.factVolumeWithPeriod || !timeFrame) {
    return DEFAULT_VOLUME;
  }

  let volume =
    filters.factVolumeWithPeriod.find(
      (factVolumes) =>
        factVolumes.periodType.localeCompare(timeFrame.toString(), undefined, {
          sensitivity: 'accent',
        }) === 0,
    )?.factVolume ?? DEFAULT_VOLUME;

  return volume === 'PLK' ? DEFAULT_UNITS_PLK : volume;
};
